import { Box, Popper } from '@mui/material';
import PropTypes from 'prop-types';

const CALENDAR_CONTAINER_BORDER = '#ddd';

CalendarEventTooltip.propTypes = {
  tooltip: PropTypes.shape({
    anchorEl: PropTypes.any,
    placement: PropTypes.oneOf(['top', 'bottom']),
    directionLabel: PropTypes.string,
    requestStatusName: PropTypes.string,
    statusColor: PropTypes.string,
    residentNames: PropTypes.string,
    transportTypeName: PropTypes.string,
    dateLabel: PropTypes.string,
    timeLabel: PropTypes.string,
  }),
  tooltipWidthPx: PropTypes.number,
};

export default function CalendarEventTooltip({ tooltip, tooltipWidthPx = 335 }) {
  if (!tooltip?.anchorEl) return null;

  return (
    <Popper
      open
      anchorEl={tooltip.anchorEl}
      placement={tooltip.placement || 'bottom'}
      modifiers={[
        { name: 'offset', options: { offset: [0, 12] } },
        { name: 'preventOverflow', options: { padding: 12 } },
        { name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } },
      ]}
      sx={{
        zIndex: 1200,
        pointerEvents: 'none',
        '&[data-popper-placement*="bottom"] .calendar-event-tooltip-arrow': {
          top: '-6px',
          transform: 'translateX(-50%) rotate(45deg)',
        },
        '&[data-popper-placement*="top"] .calendar-event-tooltip-arrow': {
          bottom: '-6px',
          transform: 'translateX(-50%) rotate(225deg)',
        },
      }}
    >
      <Box
        className="calendar-event-tooltip"
        aria-hidden="true"
        sx={{
          position: 'relative',
          width: `${tooltipWidthPx}px`,
          maxWidth: 'calc(100vw - 24px)',
          background: '#ffffff',
          border: `1px solid ${CALENDAR_CONTAINER_BORDER}`,
          borderRadius: '12px',
          boxShadow: '0 12px 30px rgba(15, 23, 42, 0.16)',
          p: '10px 14px',
          overflow: 'visible',
        }}
      >
        <Box
          component="span"
          className="calendar-event-tooltip-arrow"
          aria-hidden="true"
          sx={{
            position: 'absolute',
            left: '50%',
            width: '10px',
            height: '10px',
            background: '#ffffff',
            borderLeft: `1px solid ${CALENDAR_CONTAINER_BORDER}`,
            borderTop: `1px solid ${CALENDAR_CONTAINER_BORDER}`,
            zIndex: -1,
          }}
        />
        <Box
          className="calendar-event-tooltip-top"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '6px', gap: '8px' }}
        >
          <Box component="span" className="calendar-event-tooltip-direction" sx={{ fontSize: '11px', fontWeight: 500 }}>
            {tooltip.directionLabel}
          </Box>
          <Box
            component="span"
            className="calendar-event-tooltip-status"
            style={{ color: tooltip.statusColor }}
            sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px', lineHeight: 1.5 }}
          >
            <Box
              className="calendar-event-tooltip-status-dot"
              style={{ backgroundColor: tooltip.statusColor }}
              aria-hidden="true"
              sx={{ width: '6px', height: '6px', borderRadius: '999px', flex: '0 0 auto' }}
            />
            {tooltip.requestStatusName}
          </Box>
        </Box>
        <Box className="calendar-event-tooltip-resident" sx={{ fontSize: '14px', fontWeight: 500, m: '0 0 3px' }}>
          {tooltip.residentNames}: {tooltip.transportTypeName}
        </Box>
        <Box
          className="calendar-event-tooltip-bottom"
          sx={{ fontSize: '10px', display: 'flex', flexWrap: 'wrap', gap: '14px' }}
        >
          <Box component="span">{tooltip.dateLabel}</Box>
          <Box component="span">Apt time: {tooltip.timeLabel}</Box>
        </Box>
      </Box>
    </Popper>
  );
}
